import { RateQuote } from '../../rate';
import { RateSelectionReason } from '../../rate/RateSelectionReason';
import { RoutingGuideRule } from '../../routingGuide';

import { RoutePlanProposedShipment } from './RoutePlanProposedShipment';
import { RoutePlanShipmentResult } from './RoutePlanShipmentResult';

type ConstructableRoutePlanShipmentRequest = Partial<RoutePlanShipmentRequest> &
  Required<Pick<RoutePlanShipmentRequest, 'proposedShipment'>>;

export class RoutePlanShipmentRequest {
  proposedShipment: RoutePlanProposedShipment;
  rateQuote?: RateQuote;
  rateSelectionReason?: RateSelectionReason;
  routingGuideRule?: RoutingGuideRule;
  result?: RoutePlanShipmentResult;

  constructor(opts: ConstructableRoutePlanShipmentRequest) {
    this.proposedShipment = new RoutePlanProposedShipment(
      opts.proposedShipment,
    );

    if (opts?.rateQuote) {
      this.rateQuote = new RateQuote(opts.rateQuote);
    }

    if (opts?.rateSelectionReason) {
      this.rateSelectionReason = new RateSelectionReason(
        opts.rateSelectionReason,
      );
    }

    if (opts?.routingGuideRule) {
      this.routingGuideRule = new RoutingGuideRule(opts.routingGuideRule);
    }

    if (opts?.result) {
      this.result = new RoutePlanShipmentResult(opts.result);
    }
  }

  /** The underlying `ProposedShipment`'s identifier */
  get shipmentIdentifier() {
    return this.proposedShipment.shipmentIdentifier;
  }

  toJSON() {
    return {
      proposedShipment: this.proposedShipment,
      rateQuoteId: this.rateQuote?.id,
      rateSelectionReason: this.rateSelectionReason,
    };
  }
}
